(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/detail-view-route-play-handler/assets/javascripts/detail-view-route-play-handler.js') >= 0) return;  svs.modules.push('/components/tipsen/detail-view-route-play-handler/assets/javascripts/detail-view-route-play-handler.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;

const {
  useContext
} = React;
const {
  selectEngineDefinition
} = svs.components.tipsen.engine.selectors;
const {
  selectIsTipsinfoSupported
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  useMediaQuery
} = svs.components.lbUtils.useMediaQuery;
const {
  SideNav,
  LazyStatistic,
  LazyGameGuide,
  RoutePlayOverviewFallback,
  RoutePlayAnalysisFallback,
  LazyOdds,
  RoutePlayQuickBetFallback
} = svs.components.tipsen.sideNav;
const {
  useBranding,
  useGetIsMatchNotStartedOrLive
} = svs.components.tipsen.hooks;
const {
  useCurrentDrawEvent,
  useDrawSearchParams,
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  Route,
  useRouteMatch,
  useHistory,
  useLocation
} = ReactRouterDOM;
const {
  STATISTIC_SIDEBAR_QUERY
} = svs.components.tipsen.constants;
const {
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const {
  SportinfoPathNames,
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  tipsenLazy
} = svs.components.tipsen.tipsenLazy;
const {
  DetailViewMobileHandler
} = svs.components.tipsen.detailViewMobileHandler;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  setCouponValues
} = svs.components.tipsen.engine.actions;
const {
  useCouponId
} = svs.components.tipsen.couponId;
const {
  HeaderBetButtons
} = svs.components.tipsen.detailViewRoutePlayHandler;
const {
  VideoAnalysisPlayer
} = svs.components.tipsen.videoAnalysisPlayer;
const TipsinfoTypes = svs.components.tipsen.engine.constants.TipsinfoTypes;
const {
  selectShowVideoAnalysesInCoupon
} = svs.components.tipsen.selectors;
const LazyOverview = tipsenLazy('/cl/tipsen/route-play-overview', () => svs.components.tipsen.routePlayOverview.RoutePlayOverview, {
  fallback: RoutePlayOverviewFallback
});
const LazyAnalysis = tipsenLazy('/cl/tipsen/route-play-analysis', () => svs.components.tipsen.routePlayAnalysis.RoutePlayAnalysis, {
  fallback: RoutePlayAnalysisFallback
});
const LazyQuickBet = tipsenLazy('/cl/tipsen/route-play-quick-bet', () => svs.components.tipsen.routePlayQuickBet.RoutePlayQuickBet, {
  fallback: RoutePlayQuickBetFallback
});
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const isVideoAnalysesFeatureEnabled = !isSelfService && svs.core.detect.feature('ft-pool-betting-video-analyses');
const getMenuItems = _ref => {
  let {
    drawSearchParams,
    engine,
    isMatchNotStartedOrLive,
    matchId,
    productId,
    sportType,
    isAnalysisSupported
  } = _ref;
  const menuItems = {
    GAMEGUIDE: {
      to: {
        pathname: "/".concat(TipsenModuleGameUrl.GAME_GUIDE),
        search: drawSearchParams
      },
      icon: 'spelguide',
      label: 'Spelguide',
      testIdSuffix: 'gameguide',
      Component: LazyGameGuide,
      className: 'padding-2',
      selectedOnPaths: ["/".concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.SINGLES, "/").concat(TipsenModuleGameUrl.GAME_GUIDE)]
    },
    STATISTICS: {
      to: {
        pathname: '',
        search: drawSearchParams
      },
      icon: 'statistics',
      label: 'Statistik',
      testIdSuffix: 'statistic',
      Component: LazyStatistic,
      selectedOnPaths: ['/', "/".concat(TipsenModuleGameUrl.SYSTEM), "/".concat(TipsenModuleGameUrl.TIPS_SM), "/".concat(TipsenModuleGameUrl.TIPS_EM), "/".concat(SportinfoPathNames.News), "/".concat(SportinfoPathNames.Table), "/".concat(SportinfoPathNames.Statistic), "/".concat(SportinfoPathNames.Lineup), "/".concat(SportinfoPathNames.Mutuals), "/".concat(SportinfoPathNames.Events), "/".concat(SportinfoPathNames.PlayMakerXstat), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(SportinfoPathNames.News), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(SportinfoPathNames.Table), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(SportinfoPathNames.Statistic), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(SportinfoPathNames.Lineup), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(SportinfoPathNames.Mutuals), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(SportinfoPathNames.Events), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(SportinfoPathNames.PlayMakerXstat), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.News), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Table), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Statistic), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Lineup), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Mutuals), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Events), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.PlayMakerXstat), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.News), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Table), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Statistic), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Lineup), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Mutuals), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Events), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.PlayMakerXstat)]
    },
    OVERVIEW: {
      to: {
        pathname: "/".concat(TipsenModuleGameUrl.YOUR_COUPON),
        search: drawSearchParams
      },
      icon: 'overview',
      label: 'Översikt',
      testIdSuffix: 'overview',
      Component: LazyOverview,
      selectedOnPaths: ["/".concat(TipsenModuleGameUrl.YOUR_COUPON), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(TipsenModuleGameUrl.YOUR_COUPON), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(TipsenModuleGameUrl.YOUR_COUPON), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(TipsenModuleGameUrl.YOUR_COUPON)]
    },
    ANALYSIS: {
      to: {
        pathname: "/".concat(SportinfoPathNames.Analyze),
        search: drawSearchParams
      },
      icon: 'odds',
      label: 'Analys',
      testIdSuffix: 'analysis',
      Component: LazyAnalysis,
      selectedOnPaths: ["/".concat(SportinfoPathNames.Analyze), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(SportinfoPathNames.Analyze), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(SportinfoPathNames.Analyze), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(SportinfoPathNames.Analyze)]
    },
    ODDS: {
      ariaLabel: 'Odds - Visa mina eller mest och minst spelade odds',
      to: {
        pathname: "/".concat(TipsenModuleGameUrl.ODDS),
        search: drawSearchParams
      },
      icon: 'odds',
      label: 'Odds',
      testIdSuffix: 'odds',
      Component: LazyOdds,
      selectedOnPaths: ["/".concat(TipsenModuleGameUrl.ODDS)]
    },
    QUICKBET: {
      to: {
        pathname: "/".concat(TipsenModuleGameUrl.QUICK_BET),
        search: drawSearchParams
      },
      icon: 'odds',
      label: 'Oddset',
      testIdSuffix: 'quickbet',
      Component: LazyQuickBet,
      selectedOnPaths: ["/".concat(TipsenModuleGameUrl.QUICK_BET), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(TipsenModuleGameUrl.QUICK_BET), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(TipsenModuleGameUrl.QUICK_BET), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(TipsenModuleGameUrl.QUICK_BET)],
      props: {
        matchId,
        productId,
        sportType
      }
    }
  };
  const itemsOrder = [menuItems.GAMEGUIDE, menuItems.STATISTICS, menuItems.OVERVIEW];
  if (isAnalysisSupported) {
    itemsOrder.push(menuItems.ANALYSIS);
  }
  engine.outcomes.eventTypeId === EventTypeId.RESULT && itemsOrder.push(menuItems.ODDS);
  const extraMenuItemsOrder = [menuItems.STATISTICS];
  if (isMatchNotStartedOrLive) {
    itemsOrder.push(menuItems.QUICKBET);
    extraMenuItemsOrder.push(menuItems.QUICKBET);
  }
  return [itemsOrder, extraMenuItemsOrder];
};
const useCloseModal = () => {
  const history = useHistory();
  const location = useLocation();
  const handleClose = () => {
    const search = new URLSearchParams(location.search);
    if (search.has('openStatistic')) {
      search.delete('openStatistic');
    }
    history.push({
      search: "?".concat(search)
    });
  };
  return handleClose;
};
const DetailViewRoutePlayHandler = _ref2 => {
  let {
    hasSideNav = true
  } = _ref2;
  const dispatch = useDispatch();
  const isWideDevice = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  const sideNavOverflowClass = 'tipsen-side-nav-overflow';
  const match = useRouteMatch();
  const event = useCurrentDrawEvent();
  const {
    sportType
  } = useCurrentDraw();
  const matchId = event.matchId;
  const {
    productId,
    drawNumber,
    eventNumber
  } = useContext(DrawContext);
  const drawSearchParams = useDrawSearchParams(productId, drawNumber, eventNumber).toString();
  const brandingList = useBranding();
  const branding = brandingList[brandingList.length - 1];
  const currentEngine = useSelector(selectEngineDefinition);
  const isMatchNotStartedOrLive = useGetIsMatchNotStartedOrLive(matchId);
  const isAnalysisSupported = useSelector(state => selectIsTipsinfoSupported(state, TipsinfoTypes.Analys));
  const showVideoAnalysesInCoupon = useSelector(selectShowVideoAnalysesInCoupon);
  const [menuItems, extraMenuItems] = getMenuItems({
    drawSearchParams,
    engine: currentEngine,
    isMatchNotStartedOrLive,
    matchId,
    productId,
    sportType,
    isAnalysisSupported
  });
  const couponId = useCouponId();
  const closeModal = useCloseModal();
  const setCoupon = signs => {
    closeModal();
    dispatch(setCouponValues({
      couponId,
      signs: [{
        signs
      }]
    }));
  };
  if (extraMenuItems.length) {
    extraMenuItems[0].props = {
      setCoupon,
      matchId,
      productId,
      drawNumber,
      shouldIncludeExtraStats: isAnalysisSupported
    };
  }
  if (isWideDevice && hasSideNav) {
    return React.createElement("aside", {
      "aria-label": "Statistik",
      className: "pg_sticky_div__statistics ".concat(isSelfService ? 'col-md-6' : 'col-md-5')
    }, isVideoAnalysesFeatureEnabled && showVideoAnalysesInCoupon && React.createElement(VideoAnalysisPlayer, {
      easeInOut: true
    }), React.createElement(SideNav, {
      ariaLabel: "Spelguide, kupong\xF6versikt och statistik",
      match: match,
      menuItems: menuItems
    }, React.createElement(Route, {
      render: () => React.createElement(LazyStatistic, {
        bigStattabAreaClassName: sideNavOverflowClass,
        branding: branding,
        matchId: matchId,
        setCoupon: setCoupon
      })
    })));
  } else if (!isWideDevice) {
    return React.createElement(DetailViewMobileHandler, {
      extraMenuItems: extraMenuItems,
      headerComponent: React.createElement(HeaderBetButtons, {
        couponId: couponId,
        event: event
      })
    }, React.createElement(LazyStatistic, {
      bigStattabAreaClassName: sideNavOverflowClass,
      branding: branding,
      drawNumber: drawNumber,
      matchId: matchId,
      productId: productId,
      setCoupon: setCoupon,
      shouldIncludeExtraStats: isAnalysisSupported
    }));
  }
  return null;
};
setGlobal('svs.components.tipsen.detailViewRoutePlayHandler.DetailViewRoutePlayHandler', DetailViewRoutePlayHandler);

 })(window);